import { Check, CalendarCheck2, Info } from "lucide-react";
import { ONORARI, CONTACT } from "@/data/siteData";
import { trackBookingClick } from "@/lib/analytics";

export default function Onorari() {
  return (
    <section id="onorari" className="relative py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <p className="overline">Onorari</p>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 text-[#0B4A5A] tracking-tight">
            Tariffe chiare e trasparenti.
          </h2>
          <p className="mt-6 text-gray-600 leading-relaxed">
            Ogni visita è un percorso completo di ascolto, diagnosi e piano di
            cura personalizzato. Nessun costo nascosto.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {ONORARI.map((o) => (
            <div
              key={o.name}
              data-testid={`onorario-${o.name.toLowerCase().replace(/\s+/g, "-")}`}
              className={`relative rounded-2xl p-8 flex flex-col transition-all duration-500 ${
                o.featured
                  ? "bg-[#0B4A5A] text-white shadow-[0_20px_60px_rgba(11,74,90,0.18)]"
                  : "bg-white border border-gray-100 hover:border-[#C6A86B]/30 hover:shadow-[0_12px_40px_rgba(11,74,90,0.06)]"
              }`}
            >
              {o.featured && (
                <span className="absolute top-6 right-6 text-[10px] uppercase tracking-[0.18em] text-[#C6A86B] font-medium">
                  Consigliata
                </span>
              )}
              <p
                className={`text-[11px] uppercase tracking-[0.18em] ${
                  o.featured ? "text-[#C6A86B]" : "text-[#C6A86B]"
                }`}
              >
                {o.duration}
              </p>
              <h3
                className={`font-serif text-2xl mt-3 leading-tight ${
                  o.featured ? "text-white" : "text-[#0B4A5A]"
                }`}
              >
                {o.name}
              </h3>

              <div className="mt-6 flex items-baseline gap-1">
                <span
                  className={`text-sm ${o.featured ? "text-white/60" : "text-gray-400"}`}
                >
                  da
                </span>
                <span
                  className={`font-serif text-5xl ${
                    o.featured ? "text-white" : "text-[#0B4A5A]"
                  }`}
                >
                  €{o.price}
                </span>
              </div>
              <p
                className={`mt-1 text-xs ${
                  o.featured ? "text-white/60" : "text-gray-400"
                }`}
              >
                per visita
              </p>

              <p
                className={`mt-5 text-[15px] leading-relaxed flex-1 ${
                  o.featured ? "text-white/80" : "text-gray-600"
                }`}
              >
                {o.desc}
              </p>

              <a
                href={CONTACT.miodottore}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackBookingClick(`onorari_${o.name}`)}
                className={`mt-7 inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full text-sm font-medium transition-all duration-300 ${
                  o.featured
                    ? "bg-white text-[#0B4A5A] hover:bg-[#F9FAFB]"
                    : "bg-[#0B4A5A] text-white hover:bg-[#0D5E73]"
                }`}
              >
                <CalendarCheck2 size={16} strokeWidth={1.6} />
                Prenota
              </a>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-start gap-3 text-sm text-gray-500 max-w-3xl">
          <Info size={16} className="text-[#C6A86B] mt-0.5 flex-shrink-0" strokeWidth={1.6} />
          <p className="leading-relaxed">
            Ai prezzi indicati va aggiunta una <strong>marca da bollo di €2</strong>{" "}
            per ogni fattura, come previsto dalla normativa vigente. La visita a
            domicilio può variare in base alla distanza: contattami per un
            preventivo. Sono convenzionato con le principali assicurazioni
            sanitarie.
          </p>
        </div>
      </div>
    </section>
  );
}
